import { useEffect } from "react";

const BookJavits6 = () => {
  useEffect(() => {
    const metaNoIndex = document.createElement("meta");
    metaNoIndex.name = "robots";
    metaNoIndex.content = "noindex, nofollow";
    document.head.appendChild(metaNoIndex);
    return () => {
      document.head.removeChild(metaNoIndex);
    };
  }, []);

  return (
    <div className="fixed inset-0 bg-black overflow-hidden">
      <iframe
        src="https://quietcove.wiseingress.com/#/quietcove;uid=82024a57-cb8d-46c7-b555-4715899f7f35;source=iframe"
        className="w-full h-full border-0"
        style={{ minWidth: '100vw', minHeight: '100vh' }}
        allow="payment *; clipboard-read; clipboard-write"
        loading="eager"
        referrerPolicy="no-referrer-when-downgrade"
        title="Quiet Corner Booking Kiosk - Javits 6"
      />
    </div>
  );
};

export default BookJavits6;
